const config = { domain: 'Community', subdomain: null }

export const community = {
  Clicked: {
    Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Join_Community_Clicked: {
    Join_Community_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
}
